import React, { useContext, useEffect } from "react";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCloudArrowDown,
  faShareNodes,
} from "@fortawesome/free-solid-svg-icons";
import "../sass/Menu.scss";
import { isMobile } from "react-device-detect";
import { DomainContext } from "./context/DomainNameContext";
import { LayerContext } from "./context/LayerContext";
import { SelectedDataSet } from "./context/SelectedDataset";
import { PlayContext } from "./context/PlayContext";
import { LayerAddContext } from "./context/AddedLayer";
import { toast } from "react-toastify";

const Menu = ({ DomainList }) => {
  const { getDomainName } = useContext(DomainContext)
  const { getDomainUrl } = useContext(DomainContext);
  const {domainName}=useContext(DomainContext);
  const { getLayer } = useContext(LayerContext);
  const { getSelectedIdx } = useContext(SelectedDataSet)
  const { getSelectedDataSet } = useContext(SelectedDataSet);
  const {selectedDataSet}=useContext(SelectedDataSet);
  const { getPlay } = useContext(PlayContext)
  const { playOn } = useContext(PlayContext);
  const { layerAdded } = useContext(LayerAddContext);
  const navigate = useNavigate();
  let params = useParams();
  const city = params.city;
  // console.log(DomainList)
  useEffect(() => {
    
  }, [city])
    const notify = () => toast.warn('Wait...Image is loading', {
        position: "bottom-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme:"dark",
  });
  return (
    <div className={isMobile ? "Menu mobile" : "Menu"}>
      <span>
        {DomainList.map((name, id) => {
          const url = name.replace(/\s+/g, "_").toLowerCase();
          // console.log(url);
          return (
            <span id={`${domainName==name?"active-domain":""}`} className="navlink" onClick={() => {
              if (selectedDataSet && layerAdded == true && playOn == false || selectedDataSet == undefined) {
                getDomainName(name);
                getLayer(false);
                getDomainUrl(url);
                getSelectedIdx([]);
                getSelectedDataSet();
                getPlay(false);
                navigate("/" + city + "/" + url)
              }
              else if (playOn == true) {
                getDomainName(name);
                getLayer(false);
                getDomainUrl(url);
                getSelectedIdx([]);
                getSelectedDataSet();
                getPlay(false);
                navigate("/" + city + "/" + url)
              }
              else if (selectedDataSet && layerAdded == false) {
                // alert("ghjkl")
              notify();
              }
              
              // navigate("/" + city + "/" + url)
              // console.log(url);
            }} key={id}>
              {name}
            </span>
          );
        })}
      </span>

      {/* {!isMobile && (
        <span>
          <a href="/">
            <FontAwesomeIcon icon={faCloudArrowDown} size="lg" />
          </a>
          <a href="/">
            <FontAwesomeIcon icon={faShareNodes} size="lg" />
          </a>
        </span>
      )} */}
    </div>
  );
};

export default Menu;
